
const locations = [
  {
    "id": "d3dd40dc-8a52-4472-a59f-35f2b98ca367",
    "name": "Hamburg",
    "holidays": [
      "2024-01-01T00:00:00Z",
      "2024-03-29T00:00:00Z",
      "2024-04-01T00:00:00Z",
      "2024-05-01T00:00:00Z",
      "2024-05-09T00:00:00Z",
      "2024-05-20T00:00:00Z",
      "2024-10-03T00:00:00Z",
      "2024-10-31T00:00:00Z",
      "2024-12-25T00:00:00Z",
      "2024-12-26T00:00:00Z",
    ],
    "closingDays": [
      "2024-05-10T00:00:00Z",
      "2024-10-04T00:00:00Z",
      "2024-11-01T00:00:00Z",
      "2024-12-23T00:00:00Z",
      "2024-12-24T00:00:00Z",
      "2024-12-27T00:00:00Z",
    ],
    "isDefaultLocation": false,
  },
  {
    "id": "dd05d300-3b4b-4f68-bb2c-791e432eef99",
    "name": "Berlin",
    "holidays": [
      "2024-01-01T00:00:00Z",
      "2024-03-08T00:00:00Z",
      "2024-03-29T00:00:00Z",
      "2024-04-01T00:00:00Z",
      "2024-05-01T00:00:00Z",
      "2024-05-09T00:00:00Z",
      "2024-05-20T00:00:00Z",
      "2024-10-03T00:00:00Z",
      "2024-12-25T00:00:00Z",
      "2024-12-26T00:00:00Z",
    ],
    "closingDays": [
      "2024-05-10T00:00:00Z",
      "2024-10-04T00:00:00Z",
      "2024-12-23T00:00:00Z",
      "2024-12-24T00:00:00Z",
      "2024-12-27T00:00:00Z",
    ],
    "isDefaultLocation": false,
  },
  {
    "id": "c910ba3c-27d7-4fa8-94d7-0c22fd526492",
    "name": "Göttingen",
    "holidays": [
      "2024-01-01T00:00:00Z",
      "2024-03-29T00:00:00Z",
      "2024-04-01T00:00:00Z",
      "2024-05-01T00:00:00Z",
      "2024-05-09T00:00:00Z",
      "2024-05-20T00:00:00Z",
      "2024-10-03T00:00:00Z",
      "2024-10-31T00:00:00Z",
      "2024-12-25T00:00:00Z",
      "2024-12-26T00:00:00Z",
    ],
    "closingDays": [
      "2024-05-10T00:00:00Z",
      "2024-10-04T00:00:00Z",
      "2024-11-01T00:00:00Z",
      "2024-12-23T00:00:00Z",
      "2024-12-24T00:00:00Z",
      "2024-12-27T00:00:00Z",
    ],
    "isDefaultLocation": false,
  },
  {
    "id": "dd05d300-3b4b-5000-bb2c-791e432eef99",
    "name": "Frankfurt",
    "holidays": [
      "2024-01-01T00:00:00Z",
      "2024-03-29T00:00:00Z",
      "2024-04-01T00:00:00Z",
      "2024-05-01T00:00:00Z",
      "2024-05-09T00:00:00Z",
      "2024-05-20T00:00:00Z",
      "2024-05-30T00:00:00Z",
      "2024-10-03T00:00:00Z",
      "2024-12-25T00:00:00Z",
      "2024-12-26T00:00:00Z",
    ],
    "closingDays": [
      "2024-05-10T00:00:00Z",
      "2024-05-31T00:00:00Z",
      "2024-10-04T00:00:00Z",
      "2024-12-23T00:00:00Z",
      "2024-12-24T00:00:00Z",
      "2024-12-27T00:00:00Z",
    ],
    "isDefaultLocation": true,
  },
  {
    "id": "5cbc018b-d64b-4801-82db-fdb13d9d12a6",
    "name": "Penzberg / München",
    "holidays": [
      "2024-01-01T00:00:00Z",
      "2024-01-06T00:00:00Z",
      "2024-03-29T00:00:00Z",
      "2024-04-01T00:00:00Z",
      "2024-05-01T00:00:00Z",
      "2024-05-09T00:00:00Z",
      "2024-05-20T00:00:00Z",
      "2024-05-30T00:00:00Z",
      "2024-10-03T00:00:00Z",
      "2024-11-01T00:00:00Z",
      "2024-12-25T00:00:00Z",
      "2024-12-26T00:00:00Z",
    ],
    "closingDays": [
      "2024-05-10T00:00:00Z",
      "2024-05-31T00:00:00Z",
      "2024-10-04T00:00:00Z",
      "2024-12-23T00:00:00Z",
      "2024-12-24T00:00:00Z",
      "2024-12-27T00:00:00Z",
    ],
    "isDefaultLocation": false,
  },
]

export default locations
